import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    // {
    //   path: '/:pageId/:subpageId?/subsubpageId?',
    //   name: 'page',
    //   component: Home,
    //   props: true
    // },
    {
      // NB: have to provide a name for this param
      path: '/:pagePath(.*)',
      name: 'page',
      component: Home,
      props: true
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
